module.exports = __webpack_public_path__ + "media/images/icons/favorites_black_s-0f66c66120bb33a64f60f1c97b55066b.svg";